import React from 'react';
import { Button } from '@/components/ui/button';
import { SectionTitle } from './ui-primitives';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Download } from 'lucide-react';
import { cn } from '@/lib/utils';
const EXPORT_SIZES = [
    { value: 400, label: '400px' },
    { value: 800, label: '800px' },
    { value: 1200, label: '1200px' },
    { value: 2000, label: '2000px' },
];
export const ExportPanel = ({ ready, exportSize, onExportSizeChange, onDownloadPng, onDownloadSvg, }) => (<div className="space-y-4">
        <SectionTitle>Export Size</SectionTitle>
        <ToggleGroup type="single" value={String(exportSize)} onValueChange={(v) => v && onExportSizeChange(Number(v))} className="justify-start flex-wrap">
            {EXPORT_SIZES.map(({ value, label }) => (<ToggleGroupItem key={value} value={String(value)} className={cn('text-xs', exportSize === value && 'font-semibold')}>
                    {label}
                </ToggleGroupItem>))}
        </ToggleGroup>

        <div className="flex gap-2 pt-2">
            <Button onClick={onDownloadPng} disabled={!ready} className="flex-1 gap-1.5" aria-label="Download QR code as PNG">
                <Download className="h-4 w-4"/>
                PNG
            </Button>
            <Button variant="outline" onClick={onDownloadSvg} disabled={!ready} className="flex-1 gap-1.5" aria-label="Download QR code as SVG">
                <Download className="h-4 w-4"/>
                SVG
            </Button>
        </div>

        <p className="text-xs text-muted-foreground">
            High-DPI exports recommended for print. Use PNG for digital, SVG for scalable use cases.
        </p>
    </div>);
ExportPanel.displayName = 'ExportPanel';
